import http from '@/http'
export default {
  namespaced: true,
  state: {
    ageRange: {},
    genre: {},
    marketingPosition: {},
    marketingBilling: {},
    marketingTime: {},
    targetGroup: {},
    marketingSkill: {}
  },
  mutations: {
    setAgeRange(state, ageRange) {
      state.ageRange = ageRange
    },
    setGenre(state, genre) {
      state.genre = genre
    },
    setMarketingPosition(state, marketingPosition) {
      state.marketingPosition = marketingPosition
    },
    setMarketingTime(state, marketingTime) {
      state.marketingTime = marketingTime
    },
    setTargetGroup(state, targetGroup) {
      state.targetGroup = targetGroup
    },
    setMarketingSkill(state, skill) {
      state.marketingSkill = skill
    }
  },
  actions: {
    async suitabilityAnalyze({}, suitability) {
      const response = await http.post('settings/suitability', suitability)
      return response.data
    }
  }
}
